import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '',
  },
  {
    path: '',
    loadChildren: () => import('@modules/home/home.module').then(m => m.HomeModule),
  },
  {
    path: 'coverage',
    loadChildren: () => import('@modules/coverage/coverage.module').then(m => m.CoverageModule),
  },
  {
    path: 'documentation',
    loadChildren: () =>
      import('@modules/documentation/documentation.module').then(m => m.DocumentationModule),
  },
  {
    path: 'tracking',
    loadChildren: () => import('@modules/tracking/tracking.module').then(m => m.TrackingModule),
  },
  {
    path: 'not-found',
    loadChildren: () => import('@modules/not-found/not-found.module').then(m => m.NotFoundModule),
  },
  {
    path: 'forbidden',
    loadChildren: () => import('@modules/forbidden/forbidden.module').then(m => m.ForbiddenModule),
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
